import DivisaService from '@services/general/DivisaService';

import config from '@plugins/config';

const defaultCountryCode = config.get('COUNTRY_CODE');
const defaultCode = config.get('CURRENCY_CODE');

const currencyFormatters = {};
const getCurrencyFormatter = (code) => {
  return Object.prototype.hasOwnProperty.call(currencyFormatters, code) ? currencyFormatters[code] : currencyFormatters[code] = new Intl.NumberFormat(defaultCountryCode, { style: 'currency', currency: code});
}

export default {
    namespaced: true,

    state: () => ({
        selected: null,
        isLoading: false,
    }),

    getters: {
        selected: state => state.selected,
        isLoading: state => state.isLoading,
        format: state => (value, code = null) => {
            if (code) return getCurrencyFormatter(code).format(value);
            return getCurrencyFormatter(state.selected?.code || defaultCode).format(value);
        }
    },

    mutations: {
        setSelected: (state, divisa) => {
            state.selected = divisa;
        },
        setIsLoading: (state, isLoading) => {
            state.isLoading = isLoading;
        }
    },

    actions: {
        setSelected: ({ commit }, divisa = null) => {
            return new Promise((resolve, reject) => {
                if (divisa) {
                    commit('setSelected', divisa);
                    resolve(divisa);
                } else {
                    commit('setIsLoading', true);
                    DivisaService
                        .getDefault()
                        .then(({ divisa }) => {
                            commit('setSelected', divisa);
                            resolve(divisa);
                        })
                        .catch(error => reject(error))
                        .finally(() => {
                            commit('setIsLoading', false);
                        });
                }
            });
        },
    }
}